import { render } from "./Impressum.vue?vue&type=template&id=2e6a3145&scoped=true&ts=true"
import script from "./Impressum.vue?vue&type=script&lang=ts"
export * from "./Impressum.vue?vue&type=script&lang=ts"

import "./Impressum.vue?vue&type=style&index=0&id=2e6a3145&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6a3145"]])

export default __exports__